export default __webpack_public_path__ + "static/media/CV2.4251872f.png";